/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_TitleInputs */

const cs_requirements_title = /** @type {(inputs: Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky`)
};

const en_requirements_title = /** @type {(inputs: Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand / requirements`)
};

/**
* | output |
* | --- |
* | "Demand / requirements" |
*
* @param {Requirements_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_title = /** @type {((inputs?: Requirements_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_title(inputs)
	return cs_requirements_title(inputs)
});